/**
 * @flow
 * @relayHash 28a049d29b6de197a622b73e1eeb7087
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type TokenAuthMutationVariables = {|
  username: string,
  password: string,
|};
export type TokenAuthMutationResponse = {|
  +tokenAuth: ?{|
    +token: string,
    +user: ?{|
      +id: string,
      +firstName: string,
      +lastName: string,
      +email: string,
      +username: string,
    |},
  |}
|};
export type TokenAuthMutation = {|
  variables: TokenAuthMutationVariables,
  response: TokenAuthMutationResponse,
|};
*/


/*
mutation TokenAuthMutation(
  $username: String!
  $password: String!
) {
  tokenAuth(username: $username, password: $password) {
    token
    user {
      id
      firstName
      lastName
      email
      username
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "username",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "password",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "tokenAuth",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "password",
        "variableName": "password"
      },
      {
        "kind": "Variable",
        "name": "username",
        "variableName": "username"
      }
    ],
    "concreteType": "ObtainAdminJSONWebToken",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "token",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "user",
        "storageKey": null,
        "args": null,
        "concreteType": "UserNode",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "firstName",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "lastName",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "email",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "username",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "TokenAuthMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "TokenAuthMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "TokenAuthMutation",
    "id": null,
    "text": "mutation TokenAuthMutation(\n  $username: String!\n  $password: String!\n) {\n  tokenAuth(username: $username, password: $password) {\n    token\n    user {\n      id\n      firstName\n      lastName\n      email\n      username\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '25691a7379c3d98c20993c1db774f3ed';
module.exports = node;
